module.exports = __webpack_public_path__ + "static/media/remote-monitoring.f265b2f2.svg";